<template>
  <div>
    <ul class="container">
      <li v-for="(conf, index) in confsMobile"
      :key="index">
        <template v-if="conf.link!=='javascript:void(0)'">
          <a :href="conf.link" target="_blank" class="has-no-link">
            <img :src="conf.img" alt="">
          </a>
        </template>
        <template v-else>
          <img :src="conf.img" alt="">
        </template>
      </li>
    </ul>
    <!-- <div class="pc-container" v-else>
      <img src="https://static.geekbang.org/infoq/5afd374e67d8d.png?imageView2/0/" alt="">
      <ul class="pc1">
        <li v-for="(conf, index) in confsPC"
        :key="index">
          <a :href="conf.link" target="_blank">
            <img :src="conf.img" alt="">
          </a>
        </li>
      </ul>
      <ul class="pc2">
        <li v-for="(conf, index) in confsPC2"
        :key="index">
          <a :href="conf.link" target="_blank">
            <img :src="conf.img" alt="">
          </a>
        </li>
      </ul>
    </div> -->
  </div>
</template>
<script>
import utils from '@/util/WXshare'
export default {
  data () {
    return {}
  },
  created () {
    window.location.href = 'https://con.infoq.cn'
    // this.$ajax.post(
    //   'https://admin.geekbang.org/message/edm/info',
    //   { id: 21 }
    // ).then((res) => { console.log(res) })
  },
  computed: {
    confsMobile () {
      return [{
        link: 'javascript:void(0)',
        img: 'https://static001-test.geekbang.org/resource/image/24/b6/2401ba7473341217e645ab89b4efa7b6.jpg'
      }, {
        link: 'https://qcon.infoq.cn/2019/beijing?utm_source=geekbangconference',
        img: 'https://static001.geekbang.org/resource/image/39/01/39bb8137a10eb967dfa9d6ba25548a01.png'
      }, {
        link: 'https://qcon.infoq.cn/2019/guangzhou?utm_source=geekbangconference',
        img: 'https://static001-test.geekbang.org/resource/image/66/47/669737f9e920af20a4ccdd7970486847.jpg'
      }, {
        link: 'https://gtlc.infoq.cn/2019/shanghai?utm_source=geekbangconference',
        img: 'https://static001-test.geekbang.org/resource/image/f8/39/f8d71e9a8a36dbfc2c0727899f4c1139.jpg'
      }, {
        link: 'https://gmtc.infoq.cn/2019/beijing?utm_source=geekbangconference',
        img: require('./assets/gmtcbj.jpg')
      }, {
        link: 'https://archsummit.infoq.cn/2019/shenzhen?utm_source=geekbangconference',
        img: 'https://static001-test.geekbang.org/resource/image/15/78/153630cf6fabbe8a6ec47fdb0d7d9278.jpg'
      }, {
        link: 'https://qcon.infoq.cn/2019/shanghai?utm_source=geekbangconference',
        img: require('./assets/qconsh.png')
      }, {
        link: 'https://aicon.infoq.cn/2019/beijing?utm_source=geekbangconference',
        img: require('./assets/aiconbj.png')
      }, {
        link: 'https://archsummit.infoq.cn/2019/beijing?utm_source=geekbangconference',
        img: require('./assets/asbj.png')
      }, {
        link: 'https://gmtc.infoq.cn/2019/shenzhen?utm_source=geekbangconference',
        img: require('./assets/gmtcsz.jpg')
      }, {
        link: 'javascript:void(0)',
        img: require('./assets/footer.png')
      }]
    },
    confsPC () {
      return [{
        link: 'javascript:void(0)',
        img: 'https://static.geekbang.org/infoq/5afd33a098997.png?imageView2/0/'
      }, {
        link: 'https://aicon.geekbang.org',
        img: 'https://static.geekbang.org/infoq/5afd33a1606ba.png?imageView2/0/'
      }, {
        link: 'https://2018.qconbeijing.com',
        img: 'https://static.geekbang.org/infoq/5afd33a0d159c.png?imageView2/0/'
      }, {
        link: 'https://gtlc.geekbang.org',
        img: 'https://static.geekbang.org/infoq/5afd33a126d33.png?imageView2/0/'
      }, {
        link: 'https://gmtc.geekbang.org',
        img: 'https://static.geekbang.org/infoq/5afd33a1b4593.png?imageView2/0/'
      }, {
        link: 'https://sz2018.archsummit.com',
        img: 'https://static.geekbang.org/infoq/5afd33a208b35.png?imageView2/0/'
      }]
    },
    confsPC2 () {
      return [{
        link: 'https://bccon.geekbang.org',
        img: 'https://static.geekbang.org/infoq/5afd33a2b5f18.png?imageView2/0/'
      }, {
        link: 'https://2018.qconshanghai.com',
        img: 'https://static.geekbang.org/infoq/5afd33a2708de.png?imageView2/0/'
      }, {
        link: 'http://www.cnutcon.com',
        img: 'https://static.geekbang.org/infoq/5afd33a316eb9.png?imageView2/0/'
      }, {
        link: 'https://bj2017.archsummit.com',
        img: 'https://static.geekbang.org/infoq/5afd38ef06b1c.png?imageView2/0/'
      }, {
        link: 'https://aicon.geekbang.org',
        img: 'https://static.geekbang.org/infoq/5afd38ef7182a.png?imageView2/0/'
      }, {
        link: 'javascript:void(0)',
        img: 'https://static.geekbang.org/infoq/5afd38eeb1357.png?imageView2/0/'
      }]
    }
  },
  mounted () {
    utils.shareInWeixin({
      timelineTitle: '2019极客邦科技年度主要活动',
      messageTitle: '2019极客邦科技年度主要活动',
      desc: '2019年度技术人参会攻略'
    })
  }
}
</script>
<style scoped lang='sass'>
@import '../../style/variable.sass'

img
  vertical-align: middle

.pc-container
  width: 100%
  display: flex
  flex-direction: column
  ul.pc1
    li
      float: left
      a
        display: block
        img
          height: 138px
  ul.pc2
    li
      float: left
      a
        display: block
        img
          height: 163.412222222px

+tablet
  .container
    width: 50vw

ul
  li
    a
      display: block
      &.has-no-link
        cursor: default
  li:first-child,li:last-child
    a
      cursor: default
      img
        vertical-align: baseline

</style>
